import { useEffect, useState } from 'react'
import { listAuthors } from '../services/authors'
import { listStandards, listTextTypes } from '../services/items'

// Loads the static filter option lists (standards, authors, text types) once on
// mount. Each falls back to [] on error so the form still works.
export function useSearchroomFilterOptions() {
  const [standardOptions, setStandardOptions] = useState([])
  const [authorOptions, setAuthorOptions] = useState([])
  const [textTypeOptions, setTextTypeOptions] = useState([])

  useEffect(() => {
    let active = true
    listStandards()
      .then((rows) => active && setStandardOptions(rows))
      .catch(() => active && setStandardOptions([]))
    listAuthors()
      .then((rows) => active && setAuthorOptions(rows))
      .catch(() => active && setAuthorOptions([]))
    listTextTypes()
      .then((rows) => active && setTextTypeOptions(rows))
      .catch(() => active && setTextTypeOptions([]))
    return () => {
      active = false
    }
  }, [])

  return { standardOptions, authorOptions, textTypeOptions }
}
